// @ts-nocheck
(function () {
  'use strict';
  window.AIFlorist = window.AIFlorist || {};
  var debug = window.AIFlorist.debug || { log: function () {}, warn: function () {}, error: function () {} };

  function create(deps) {
    async function sendMessage(text, images, referenceImages, uiOptions, replyTo) {
      var conversationId = deps.getConversationId();
      if (!conversationId) {
        debug.warn('[AI Florist] sendMessage called without conversationId — new conversation will be created.');
      }

      var payload = {
        conversationId: conversationId,
        message: text,
        requesterId: deps.getRequesterId ? deps.getRequesterId() : '',
        attribution: deps.getChatAttribution(),
        locale: deps.localeContext.locale,
        language: deps.localeContext.language,
      };

      var idState = deps.identity.state;
      if (idState.consentGiven) {
        payload.customer = deps.getCustomerIdentity();
      }

      var primaryImage = images && images.length ? images[0] : null;
      if (primaryImage) {
        payload.image = {
          mimeType: primaryImage.mimeType,
          data: primaryImage.data,
        };
      }
      if (images && images.length > 0) {
        payload.images = images.map(function (img) {
          return { mimeType: img.mimeType, data: img.data };
        });
      }

      if (referenceImages && referenceImages.length > 0) {
        payload.referenceImages = referenceImages.map(function (item) {
          return { key: item.key, name: item.name };
        });
      }

      if (replyTo && replyTo.messageId && replyTo.snippet) {
        payload.replyTo = {
          messageId: replyTo.messageId,
          role: replyTo.role === 'assistant' ? 'assistant' : 'user',
          snippet: String(replyTo.snippet),
          hasImage: !!replyTo.hasImage,
          imageUrl: replyTo.imageUrl || undefined,
          timestamp: replyTo.timestamp,
        };
      }

      await deps.sender.send(payload, false, uiOptions || null);
    }

    function shouldExpectGenerationFromContext(userText) {
      var normalized = String(userText || '').trim().toLowerCase();
      if (!normalized) return false;
      var isApproval = /\b(ok|okay|yes|yep|sure|go ahead|do it|lets do it|let's do it|sounds good|please do|proceed)\b/
        .test(normalized);
      if (!isApproval) return false;
      // Keep this narrow so we don't show shimmer on long non-generation instructions.
      if (normalized.length > 80) return false;

      var assistantBubbles = deps.messagesEl.querySelectorAll('.afc-msg--assistant .afc-bubble--assistant');
      if (!assistantBubbles.length) return false;
      var lastBubble = assistantBubbles[assistantBubbles.length - 1];
      var lastAssistantText = (lastBubble && lastBubble.textContent ? lastBubble.textContent : '').toLowerCase();
      return /(bring (this|it) to life|shall i|would you like me to create|want me to create|generate (it|this|now)|design (it|this)|create (it|this|now)|would you like me to proceed|confirm and i(?:'|’)ll create)/i
        .test(lastAssistantText);
    }

    function handleSubmit(e) {
      e.preventDefault();
      var text = deps.inputEl.value.trim();
      var imagesToSend = deps.media.getPendingImages ? deps.media.getPendingImages() : [];
      var imageToSend = imagesToSend[0] || null;
      var libSelections = deps.media.getLibrarySelections();
      var replyTo = deps.reply ? deps.reply.getTarget() : null;
      if ((!text && imagesToSend.length === 0 && libSelections.length === 0) || deps.getIsLoading()) return;

      if (deps.analytics && deps.analytics.trackMessageSent) {
        deps.analytics.trackMessageSent({
          interactionSource: 'chat_input',
          hasText: !!text,
          hasImage: imagesToSend.length > 0,
          referenceImageCount: libSelections.length,
          hasConversationId: !!deps.getConversationId(),
        });
      }

      var refUrls = [];
      for (var i = 0; i < libSelections.length; i++) {
        refUrls.push({
          url: deps.workerUrl + '/images/' + libSelections[i].key,
          name: libSelections[i].name,
        });
      }

      var nowTs = Date.now();
      deps.render.message(
        'user',
        text || '',
        null,
        imageToSend ? imageToSend.dataUrl : null,
        refUrls,
        imagesToSend.map(function (img) { return img.dataUrl; }),
        {
          replyTo: replyTo || null,
          timestamp: nowTs,
        }
      );
      deps.inputEl.value = '';
      deps.resetInputHeight(deps.inputEl);
      deps.media.clearPendingImage();
      if (deps.reply) deps.reply.clearTarget();
      deps.render.clearFailedMessage();

      var inferredUiOptions = shouldExpectGenerationFromContext(text || '')
        ? { expectGeneration: true }
        : null;

      var continueSend = function () {
        sendMessage(text, imagesToSend, libSelections, inferredUiOptions, replyTo);
      };

      if (deps.beforeFirstCustomerAction) {
        deps.beforeFirstCustomerAction(continueSend);
        return;
      }

      continueSend();
    }

    async function handleNewChat() {
      if (deps.getIsLoading()) return;

      var conversationId = deps.getConversationId();
      var idState = deps.identity.state;
      if (conversationId && idState.consentGiven) {
        try {
          await deps.apiFetch(deps.workerUrl + '/conversation/' + conversationId + '/archive', {
            method: 'POST',
            headers: buildRequesterHeaders(deps, { 'Content-Type': 'application/json' }),
          });
        } catch (err) {
          debug.error('[AI Florist] Archive error:', err);
        }
      }

      deps.setConversationId(null);
      localStorage.removeItem(deps.cidKey);
      if (window.AIFlorist && window.AIFlorist.send && window.AIFlorist.send.setConversationState) {
        window.AIFlorist.send.setConversationState(null);
      }
      deps.setChatTitle(null);
      deps.render.clearMessages();
      deps.render.message('assistant', deps.getWelcome(), null, null, null, null, { welcomeCta: true });
      if (deps.reply) deps.reply.clearTarget();
      deps.media.clearAll();
      if (deps.flowerLib) deps.flowerLib.clearSelected();
      deps.history.close();
      if (deps.flowerLib) deps.flowerLib.close();
    }

    return {
      sendMessage: sendMessage,
      handleSubmit: handleSubmit,
      handleNewChat: handleNewChat,
      shouldExpectGenerationFromContext: shouldExpectGenerationFromContext,
    };
  }

  function buildRequesterHeaders(deps, headers) {
    var next = Object.assign({}, headers || {});
    var requesterId = deps.getRequesterId ? deps.getRequesterId() : '';
    if (requesterId) {
      next['X-AIFLORIST-Requester-Id'] = requesterId;
    }
    return next;
  }

  window.AIFlorist.controller = {
    create: create,
  };
})();
